import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCoverageAndGap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#CoverageAndGap_svg__a)">
      <path d="M1.8 12.776C1.8 15.661 4.181 18 7.118 18a5.32 5.32 0 0 0 4.889-3.168 7 7 0 0 1-.343.009c-3.61 0-6.535-2.874-6.535-6.42q0-.252.02-.498C3.186 8.692 1.8 10.575 1.8 12.776" />
      <path d="M5.148 7.923a5.4 5.4 0 0 1 1.97-.371c2.936 0 5.318 2.34 5.318 5.224 0 .73-.153 1.425-.429 2.056 3.45-.175 6.193-2.979 6.193-6.412S15.274 2 11.664 2 5.407 4.609 5.148 7.923" />
    </g>
    <defs>
      <clipPath id="CoverageAndGap_svg__a">
        <path d="M18.2 2H1.8v16h16.4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCoverageAndGap;
